export enum DownloadState {
  PENDING = 'started',
  READY = 'done',
  DOWNLOADING = 'downloading',
  FINISHED = 'finished',
  ERROR = 'error',
}
